//import Vue from 'vue';
import router from '../router';
import axios from 'axios';

import sessionHandling from '../session-handling';

export default {
    then: (cb) => {
        return response => {
            cb(response.data);
        }
    },
    catch: (errorCb, vue) => {
        return e => {
            if (!axios.isCancel(e)) {
                // 4xx responses are expected, handled application states (401
                // triggers the session-check/redirect flow below, 400/403 are
                // routed to the caller's own errorCb -- e.g. TeamDetails.vue
                // treats a 400 "not part of a team" as a normal, non-error
                // render state) -- only genuinely unexpected failures (server
                // errors, network issues) are worth a console.error.
                if (!e.response || e.response.status >= 500) {
                    console.error('axios default-handlers: ', e);
                }

                // No response at all -- an actual network failure, or an
                // exception thrown inside the caller's own success callback
                // landing here. Hand it straight to the caller instead of
                // dereferencing e.response and throwing a second error that
                // would skip the finally handler (leaving spinners stuck).
                if (!e.response) {
                    if (errorCb) {
                        errorCb(e);
                    }

                    return null;
                }

                if (e.response.status == 401) {
                    axios.get(window.kgkRoutes.sessionCheck, {}).then(() => {
                        if (errorCb) {
                            errorCb(e);
                        }
                    }).catch(() => {
                        // recurring user, redirect because session is broken
                        if (localStorage.getItem('kgkDbSessionToken') != null && localStorage.getItem('kgkDbSessionToken') != "") {
                            vue.$notify({
                                type: 'error',
                                title: 'Anmeldung erforderlich.',
                                text: vue.$global.session.token ? 'Sie wurden wegen Inaktivität abgemeldet.' : '',
                                duration: 12000,
                            });

                            sessionHandling.logout();

                            vue.$modal.hide('dialog');
                            router.push('/login');
                        } else if (errorCb) {
                            // No prior session to speak of -- e.g. a failed login
                            // attempt itself returning 401 for bad credentials.
                            // Let the caller show its own error instead of
                            // silently swallowing it here.
                            errorCb(e);
                        }

                        return null; // Return null to indicate that the error has been handled
                    });

                    return null; // Return null to indicate that the error has been handled
                }

                const data = e.response.data || {};

                if (e.response.status == 403 || typeof data.code !== 'undefined') {
                    if (data.code === 'rest_campaign_not_running') {
                        vue.$notify({
                            type: 'warn',
                            title: 'Aktionszeitraum abgelaufen',
                            text: data.message || 'Der Aktionszeitraum ist abgelaufen.',
                        });

                        return null; // Return null to indicate that the error has been handled
                    }
                }

                if (errorCb) {
                    errorCb(e);
                }

                return null; // Return null to indicate that the error has been handled
            }
        }
    },
    finally: (finallyCb) => {
        return () => {
            if (finallyCb) {
                finallyCb();
            }
        }
    }
}
